import { createContext, ReactNode, useContext } from 'react';

export type NavExperience = 'business' | 'consumer';

// The base path segment a consumer-experience link is prefixed with. The business
// (default) experience adds no segment, so its links resolve exactly as before.
export const CONSUMER_BASE_PATH = 'account';

const NavExperienceContext = createContext<NavExperience>('business');

const NavExperienceProvider: React.FC<{ experience: NavExperience; children: ReactNode }> = ({
  experience,
  children
}) => <NavExperienceContext.Provider value={experience}>{children}</NavExperienceContext.Provider>;

const useNavExperience = () => useContext(NavExperienceContext);

export { NavExperienceContext, NavExperienceProvider, useNavExperience };
